import { render, staticRenderFns } from "./ProviderTasks.vue?vue&type=template&id=a0701952"
import script from "./ProviderTasks.vue?vue&type=script&lang=js"
export * from "./ProviderTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports